<template>
  <div id="app">
    <Home/>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
html{
  scroll-behavior: smooth;
}
#app {
  font-family: "Poppins", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  font-size: 20px;
  scroll-behavior: smooth;
  scroll-margin: 80px;
}

/* NAVBAR */
.btn-contacto a,
.navbar-light .navbar-nav .nav-link .btn-contacto{
  color: #fff !important;
}

/* SLICK ASSETS */
.assets .slick-next{
  right: 5% !important;
  opacity: 1 !important;
}
.assets .slick-next:before{
  content: url('./assets/icn_arrow_der_w.png');
  opacity: 1 !important;
}
.assets .slick-prev{
  left: 5% !important;
  z-index: 2;
  opacity: 1 !important;
}
.assets .slick-prev:before{
  content: url('./assets/icn_arrow_izq_w.png');
  opacity: 1 !important;
}

.modelo-slider .slick-next,
.interiores .slick-next{
  right: 5% !important;
  opacity: 1 !important;
}
.modelo-slider .slick-next:before,
.interiores .slick-next:before{
  content: url('./assets/icn_arrow_der.png');
  opacity: 1 !important;
}
.modelo-slider .slick-prev,
.interiores .slick-prev{
  left: 5% !important;
  z-index: 2;
  opacity: 1 !important;
}
.modelo-slider .slick-prev:before,
.interiores .slick-prev:before{
  content: url('./assets/icn_arrow_izq.png');
  opacity: 1 !important;
}

.modeloimgs .slick-slide{
  padding: 5px;
}

/* MODAL FOLLETO */
#modal-center .modal-content{
  border-radius: 20px !important;
  border: none !important;
}
#modal-center .modal-body{
  padding: 0;
  background: #CDBBA7;
  border: none !important;
  border-radius: 20px !important;
}
</style>
